"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TopNavStyled = require("./TopNav-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TopNav = function TopNav(_ref) {
  var children = _ref.children,
      contentWidth = _ref.contentWidth,
      contentMaxWidth = _ref.contentMaxWidth,
      other = _objectWithoutProperties(_ref, ["children", "contentWidth", "contentMaxWidth"]);

  return _react.default.createElement(_TopNavStyled.StyledTopNavContainer, null, _react.default.createElement(_TopNavStyled.StyledTopNav, _extends({
    contentWidth: contentWidth,
    contentMaxWidth: contentMaxWidth
  }, other), children, ' '));
};

TopNav.propTypes = {
  /** The content of the component. */
  children: _propTypes.default.node,

  /** Override for contentWidth from CalciteThemeProvider (ex. '1300px'). Use "100%" for full width TopNav. */
  contentWidth: _propTypes.default.string,

  /** Override for contentMaxWidth from theme provider (ex. '95vw').*/
  contentMaxWidth: _propTypes.default.string
};
TopNav.defaultProps = {};
TopNav.displayName = 'TopNav';
var _default = TopNav;
exports.default = _default;